import { connect } from 'react-redux';
import Login from 'es6/components/pages/login';
import { getSiteConfiguration } from 'es6/helpers/selectors';

function mapStateToProps(state) {
  return { siteConfiguration: getSiteConfiguration(state) };
}

export default connect(mapStateToProps)(Login);
